import { useState } from "react";
import { url } from "../utils/config";
import axios from "axios";
import Table from "../reusable_components/Table";
import AddOtherList from "../modals/AddOtherList";
import { toast } from "react-toastify";
import Button from "../reusable_components/Button";
import { btnGreen, btnRed, title, btnOneNoWidth } from "../utils/style";
import edit from '../assets/icons/edit.png'
import deleteIcon from '../assets/icons/delete.png'
import ConfirmationModal from "../reusable_components/ConfirmationModal";
import { convertMinToHour } from "../utils/dateTime";


function OtherList() {
    const [showddAndModifyOther, setShowAddAndModifyOther] = useState(false);
    const [otherData, setOtherData] = useState()
    const [deleteId, setDeleteId] = useState(null)
    const [reloadTable, setReloadTable] = useState(false)

    function toggleModify(data) {
        setOtherData(data);
        setShowAddAndModifyOther(true)
    }

    async function deleteOther() {
        try {
            const reqUrl = url + '/services/other_list/' + deleteId;
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.delete(reqUrl, { headers });
            toast.success(data.message, { autoClose: 3000 })
            console.log(data);
            setReloadTable(1 + Math.random())
        } catch (error) {
            toast.error(error?.response?.data?.message || error.message, { autoClose: 3000 })
            console.log(error)
        }
    }

    const options = [
        {
            header: 'Resource Name',
            key: 'name',
        },
        {
            header: 'Estimated Time',
            key: 'estimatedTime',
            render: (data) => { return convertMinToHour(data.estimatedTime) },
        },
        {
            header: 'Cost Type',
            key: 'costType',
        },
        {
            header: 'Action',
            render: (data) => {
                return (
                    <>
                        <button
                            className={'bg-customOne p-2 rounded-full mr-4'}
                            onClick={() => toggleModify(data)}
                        >
                            <img src={edit} height={15} width={15} />
                        </button>
                        <button
                            className={'bg-customOne p-2 rounded-full mr-4'}
                            onClick={() => setDeleteId(data.id)}
                        >
                            <img src={deleteIcon} height={15} width={15} />
                        </button>
                    </>
                )
            }
        }
    ]

    const excludeFilter = ['Action']

    return (
        <div className="p-4">
            {
                showddAndModifyOther && <AddOtherList otherData={otherData} reload={setReloadTable} setOtherData={setOtherData} setShowModal={setShowAddAndModifyOther} />
            }
            {
                deleteId && <ConfirmationModal title={'Other Service'} setShowForm={setDeleteId} confirm={deleteOther} />
            }
            <div className="flex justify-between items-center mb-4">
                <div className={title}>Other</div>
                {(
                    <Button className={`${btnOneNoWidth}`} name={`Add Other`} clickHandler={() => setShowAddAndModifyOther(!showddAndModifyOther)} />
                )}
            </div>
            <Table
                options={options}
                url={url + '/services/other_list'}
                pagination
                clickHandler={() => setShowAddAndModifyOther(!showddAndModifyOther)}
                btnTitle={'Other'}
                excludeFilter={excludeFilter}
                reloadTable={reloadTable}
                noButton={true}
            />
        </div>
    )
}

export default OtherList;